const l = `<svg width="56" height="56" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <path
            d="M6.68 33.804a2.044 2.044 0 00-.504.734A2.38 2.38 0 006 35.45a2.256 2.256 0 001.12 2c.344.202.735.304 1.171.304.688 0 1.234-.22 1.637-.658l19.286-19.792H26.52l19.285 19.792c.42.438.966.658 1.637.658.436 0 .827-.102 1.17-.304a2.256 2.256 0 001.121-2c0-.658-.227-1.206-.68-1.645L29.566 13.76a2.398 2.398 0 00-.768-.557A2.176 2.176 0 0027.88 13c-.671 0-1.242.253-1.712.76L6.68 33.803z"
            fill="currentColor" fill-rule="nonzero" />
        <path d="M0 0h56v56H0z" />
    </g>
</svg>`;
export {
  l as default
};
//# sourceMappingURL=arrow-up.es-BKyXcjR4.js.map
